import {
	GET_POST_INPUT_JSON_SCHEMA,
	GET_POST_INPUT_SCHEMA,
	PUBLIC_POST_ERROR_MESSAGES,
	type PublicPostSnapshot,
} from './getPostContract'

type GetPostModelContext = Pick<WebMCP.ModelContext, 'registerTool'>
type FetchPublicOriginalPost = (id: string, signal?: AbortSignal) => Promise<PublicPostSnapshot>

let getPostToolRegistration: Promise<void> | undefined

function createGetPostTool(
	fetchPublicOriginalPost: FetchPublicOriginalPost
): WebMCP.ModelContextTool {
	return {
		name: 'get_post',
		title: '获取即刻动态',
		description:
			'Get a public original Jike post snapshot by ID for static activity page generation.',
		inputSchema: GET_POST_INPUT_JSON_SCHEMA,
		annotations: {
			readOnlyHint: true,
			untrustedContentHint: true,
		},
		// Chrome 151 omits callback options even though webmcp-types@0.1.5 marks them as required.
		execute: async (input, options?: WebMCP.ToolExecuteCallbackOptions) => {
			const result = GET_POST_INPUT_SCHEMA.safeParse(input)

			if (!result.success) {
				throw new Error(PUBLIC_POST_ERROR_MESSAGES.invalidId)
			}

			return fetchPublicOriginalPost(result.data.id, options?.signal)
		},
	}
}

export function registerGetPostTool(
	modelContext: GetPostModelContext | undefined,
	fetchPublicOriginalPost: FetchPublicOriginalPost
): Promise<void> {
	if (!modelContext) {
		return Promise.resolve()
	}

	if (!getPostToolRegistration) {
		getPostToolRegistration = Promise.resolve()
			.then(() => modelContext.registerTool(createGetPostTool(fetchPublicOriginalPost)))
			.catch(() => {
				getPostToolRegistration = undefined
			})
	}

	return getPostToolRegistration
}
